import React, { useContext, useEffect } from "react";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import AuthContext from "../auth/AuthContext";
import { maybeSyncFinanceIfStale } from "../utils/financeSync";
import AppTopNav from "./AppTopNav";

function FinanceBackgroundSync() {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!user?.is_admin) return;
    maybeSyncFinanceIfStale();
  }, [user?.is_admin, location.pathname]);

  return null;
}

function ShellLayout() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
      }}
    >
      <FinanceBackgroundSync />
      <AppTopNav />
      <Box
        component="main"
        sx={{
          flex: 1,
          width: "100%",
          maxWidth: 960,
          mx: "auto",
          px: { xs: 2, sm: 3 },
          py: { xs: 3, sm: 4 },
        }}
      >
        <Outlet />
      </Box>
      <Box
        component="footer"
        sx={{
          borderTop: 1,
          borderColor: "divider",
          py: 2,
          px: 2,
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          sx={{ maxWidth: 960, mx: "auto" }}
        >
          <Link component={RouterLink} to="/privacy" color="text.secondary" underline="hover" variant="body2">
            Privatlivspolitik
          </Link>
          <Link component={RouterLink} to="/terms" color="text.secondary" underline="hover" variant="body2">
            Vilkår
          </Link>
        </Stack>
      </Box>
    </Box>
  );
}

export default ShellLayout;
